import { IBrandReviewsSummary } from '@faire/web-api--source/indigofair/data/IBrandReviewsSummary';
import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { IImage } from '@faire/web-api--source/indigofair/data/IImage';
import { IRetailerBoard } from '@faire/web-api--source/indigofair/data/IRetailerBoard';

export namespace IGetBoardItemsGroupByBrandsScrollResponse {
  export namespace IRetailerBoardItemsCollection {
    /**
     * Return an instance of IRetailerBoardItemsCollection with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IRetailerBoardItemsCollection>
    ): IRetailerBoardItemsCollection =>
      ({
        items: [],
        ...(partial ?? {}),
      }) as IRetailerBoardItemsCollection;
  }

  export interface IRetailerBoardItemsCollection {
    items: Array<IRetailerBoard.IItem>;
    brand_token: string | undefined;
    /**
     * Use brandReviewsSummary
     * @deprecated
     */
    brand_overall_rating: number | undefined;
    product_count: number | undefined;
    brand_name: string | undefined;
    brand_profile_image: IImage | undefined;
    brand_first_order_minimum: IFaireMoney | undefined;
    brand_reorder_minimum: IFaireMoney | undefined;
    based_in_city: string | undefined;
    based_in_state: string | undefined;
    /**
     * Used to display discount matching on mobile during the FWM/FSM.
     */
    brand_promo_string: string | undefined;
    /**
     * @deprecated
     */
    faire_winter_market_apparel_preorder_special_eligibility:
      | boolean
      | undefined;
    /**
     * Used to represent if brand is enrolled into preferred partner
     * @deprecated
     */
    loyalty_program_enrolled: boolean | undefined;
    /**
     * isHighlightedBrandForPromotionalEvent is used to highlight brands during a promotional event.
     * This will mirror the behavior used during FWM 2021 in faireWinterMarketApparelPreorderSpecialEligibility,
     * which highlighted apparel preorder brands. For the FSM 2021, this will be used to highlight international brands.
     */
    is_highlighted_brand_for_promotional_event: boolean | undefined;
    /**
     * True if the brand qualifies as a Top Shop for the current cycle
     */
    is_top_shop: boolean | undefined;
    brand_reviews_summary: IBrandReviewsSummary | undefined;
  }

  /**
   * Return an instance of IGetBoardItemsGroupByBrandsScrollResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetBoardItemsGroupByBrandsScrollResponse>
  ): IGetBoardItemsGroupByBrandsScrollResponse =>
    ({
      brand_token_to_items: {},
      brands_display_order: [],
      ...(partial ?? {}),
    }) as IGetBoardItemsGroupByBrandsScrollResponse;
}

export interface IGetBoardItemsGroupByBrandsScrollResponse {
  scroll_token: string | undefined;
  brand_token_to_items: Partial<
    Record<
      string,
      IGetBoardItemsGroupByBrandsScrollResponse.IRetailerBoardItemsCollection
    >
  >;
  /**
   * Upper bound the number of items remaining to scroll through
   */
  remaining_items: number | undefined;
  /**
   * iOS dictionary parsing clobbers the order of the map
   */
  brands_display_order: Array<string>;
}
